<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      areas: null,
    };
  },
  methods: {
    getAreas() {
      this.areas = null;

      api
        .get('telemedicina/areas')
        .then((response) => {
          if (response.data.status == 'success') {
            this.areas = response.data.list;
          }
        })
    },
  },
  mounted() {
    this.getAreas();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Agendamento</h3>
        <p>Marque suas consultas de forma rápida e prática.</p>
      </div>
    </div>

    <h5 v-if="areas" class="mb-4">Com qual área de atuação você gostaria de agendar?</h5>

    <div v-if="!areas" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>
    <div v-else class="row">
      <div class="col-lg-6" v-for="(area, index) in areas" :key="index">
        <router-link class="text-dark" tag="a" :to="'/telemedicina/agendamento/' + area.slug">
          <div class="card card-icon">
            <div class="card-body d-flex align-items-center">
              <div class="icon" v-html="area.icon"></div>
              <div class="ml-3 flex-fill">
                <h5 class="mb-0">{{ area.name }}</h5>
              </div>
              <div class="ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </Layout>
</template>